import MultiSelectFilterCard from "../../theme/components/MultiSelectFilterCard";

export default function AutoFilter({
  definition,
  options,
}: {
  definition: {
    key: string;
    texts?: {
      title: string;
    };
    value: string;
  };
  options: Array<{
    definition: {
      value: string;
      texts?: {
        title: string;
      };
    };
    filteredProductsCount: number;
  }>;
}) {
  /* If we ever had special filter types, we could map it here based on the key */

  return (
    <MultiSelectFilterCard
      key={definition.key}
      title={definition.texts?.title}
      searchParamName={`*${definition.key}`}
      filterItems={options.map((filteredOption) => ({
        key: filteredOption.definition.value,
        value: filteredOption.definition.value,
        label: filteredOption.definition.texts?.title,
        indicator: filteredOption.filteredProductsCount,
      }))}
    />
  );
}
